import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/AccordionBlockGraphQL/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TeamBlockGraphQL"] */ "/home/node/app/src/app/_blocks/TeamBlockGraphQL/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/AccordionBlock/AccordionBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/ApplicationHero/ApplicationHero.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/ApplicationHeroGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/BeforeAndAfterGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/GalleryPageGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/KontactGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/PageHeroGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/ProjectBlockGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/TextGalleryGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/VideoBlockGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/BeforeAndAfter/BeforeAndAfter.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/ComparisonTable/ComparisonTable.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/ComparisonTableGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/Content/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/HomepageHeroGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/ProductHeroGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/TextIframeBlockGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/DebugJsonBlock.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/FeaturesBlock/FeaturesBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/FeaturesBlockGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/FormBlockGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/MediaBlock/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/TextBlockGraphQL/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["FormBlock"] */ "/home/node/app/src/app/_components/Form/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/GalleryBlock/GalleryBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/GalleryBlockGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/GalleryPage/GalleryPage.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/HomepageHero/HomepageHero.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/IframeBlockGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/MatchingProductsGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/MusterGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_blocks/TopicsBlockGraphQL/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/BackgroundColor/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/IframeBlock/IframeBlock.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/Kontact/Kontact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivePreviewListener"] */ "/home/node/app/src/app/_components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/MatchingProducts/MatchingProducts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/home/node/app/src/app/_components/Media/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/home/node/app/src/app/_components/Media/Video/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/Muster/Muster.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/ResimdoIcon/ResimdoIcon.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/PageHero/PageHero.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/ProductHero/ProductHero.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/ProjectBlock/ProjectBlock.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SiteError"] */ "/home/node/app/src/app/_components/SiteError/SiteError.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/TextBlock/TextBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/TextGallery/TextGallery.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/TextIframeBlock/TextIframeBlock.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/TopicsBlock/TopicsBlock.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/VerticalPadding/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/app/_components/VideoBlock/VideoBlock.tsx");
